import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from '../../../Constants/Routes.constants';
import { selectEventById } from '../../../store/events';
import { useLanguage, useNavigation } from '../../../Hooks';
import BookingComponent from './Booking.component';

export const useBookingContainer = () => {
  const { t } = useLanguage();
  const { pushBack, getParams } = useNavigation();
  const { id } = getParams();
  const eventToBook = useSelector(selectEventById(id || ''));

  return {
    t,
    pushBack,
    eventName: eventToBook?.name,
  };
};

const BookingContainer = () => {
  const { eventName, pushBack } = useBookingContainer();

  if (!eventName) {
    pushBack(Route.PROVIDER_DETAIL);
    return null;
  }

  return <BookingComponent eventName={eventName} />;
};

export default BookingContainer;
